import React from "react";
import { Dialog } from "primereact/dialog";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import useComments from "../hooks/useComments";
import CommentsSection from "../components/commentsSection";

const StyledDialog = styled(Dialog)`
  min-width: 600px;
  max-width: 800px;
  width: 90vw;
  max-height: 80vh;

  .p-dialog-content {
    padding: 0;
    display: flex;
    flex-direction: column;
  }

  .p-dialog-header {
    padding: 1.5rem 2rem 1rem 2rem;
    border-bottom: 1px solid #e1e5e9;
  }

  .p-dialog-footer {
    padding: 1rem 2rem 1.5rem 2rem;
    border-top: 1px solid #e1e5e9;
  }
`;

interface CommentDialogProps {
  visible: boolean;
  onHide: () => void;
  reportId: number;
}

const CommentDialog: React.FC<CommentDialogProps> = ({
  visible,
  onHide,
  reportId,
}) => {
  const { t } = useTranslation();

  const { comments, isLoadingComments, addComment, isAddingComment } =
    useComments({ reportId });

  return (
    <StyledDialog
      header={t("header-comments")}
      visible={visible}
      onHide={onHide}
      modal
      resizable
    >
      <CommentsSection
        comments={comments}
        reportId={reportId}
        isLoading={isLoadingComments}
        onAddComment={addComment}
        isAddingComment={isAddingComment}
        mode="dialog"
      />
    </StyledDialog>
  );
};

export default CommentDialog;
